<template>
  <div class="ToolMenus">
    <ToolMenu name="Type of Tool" shortname="type"></ToolMenu>
    <ToolMenu name="Topic" shortname="topic"></ToolMenu>
    <ToolMenu name="Grade" shortname="grade"></ToolMenu>
    <ToolMenu name="More..." shortname="more"></ToolMenu>
  </div>
</template>

<script>
import ToolMenu from '@/components/ToolMenu'
export default {
  name: 'ToolMenus',
  components: { ToolMenu },
  date () {
    return {
      //
    }
  },
  methods: {
    //
  }
};
</script>

<style scoped lang="scss">
  .ToolMenus {
    width: 50%;
    float: left;
    padding-right: 30px;
    @include smx { width: 100%; float: none; padding-left: 15px; }
  }
</style>
